export const retryLazyLoad = (fn, retriesLeft = 5, interval = 500) => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch(error => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            reject(error);
            return;
          }

          // Passing on "reject" is the important part
          retryLazyLoad(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};
